<script>
import { generateConnectOnboardingDocument, generateCustomerConnectOnboardingDocument } from '@/api/cars'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import CancelButton from '@/components/cars/edit/CancelButton.vue'
import Notice from '@/components/cars/edit/Notice.vue'
import download from 'downloadjs'

export default {
  components: {
    'mia-cancel-button': CancelButton,
    'mia-notice': Notice,
    'mia-submit-button': SubmitButton
  },

  props: {
    car: {
      type: Object,
      default() {
        return {}
      }
    },

    customer: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data: () => ({
    showUploadHint: false
  }),

  computed: {
    hasCustomer() {
      return !!this.customer && Object.keys(this.customer).length > 0
    }
  },

  methods: {
    async generateAndDownload() {
      if (this.$wait.is('generating connect onboarding document')) {
        return
      }

      this.$wait.start('generating connect onboarding document')
      const [error, response] = await (this.hasCustomer ? generateCustomerConnectOnboardingDocument(this.customer.id) : generateConnectOnboardingDocument(this.car.id))
      this.$wait.end('generating connect onboarding document')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Dokument konnte nicht erzeugt werden']
        })
        return
      }

      const matches = response.headers['content-disposition'].match(/filename="(.*?)"/)
      const fileName = matches[1].trim()

      download(response.data, fileName, response.data.type)

      window.eventBus.$emit('mia-info', {
        info: ['Dokument erfolgreich erzeugt und heruntergeladen']
      })

      if (this.hasCustomer) {
        this.$emit('closed')
      } else {
        this.showUploadHint = true
      }
    }
  }
}
</script>

<template>
  <mia-modal
    id="connect-onboarding-modal"
    classes="v--modal flex flex-col"
    width="50%"
    height="auto"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <mia-modal-header>
      <h3 class="py-0 my-0">
        Connect Onboarding
      </h3>
    </mia-modal-header>

    <div class="p-4">
      <mia-notice permanent>
        Bitte Klicken Sie auf <strong>Einverständniserklärung erzeugen</strong> um das herstellerspezifische Connect Formular zu erzeugen und herunterzuladen.<br><br>
        Das unterschriebene Dokument kann danach unter <strong>Verkaufsmeldung & Auslieferung</strong> am Fahrzeug zusammen mit den Connect-Daten hinterlegt werden.
      </mia-notice>

      <div
        v-if="showUploadHint"
        class="mt-4"
      >
        Unterschriebene Einverständniserklärung <router-link
          :to="`/cars/${car.id}/disponieren#verkauf-connect-einverstaendniserklaerung`"
          class="hover:underline"
        >
          jetzt am Fahrzeug hinterlegen.
        </router-link>
      </div>
    </div>

    <mia-modal-footer class="flex items-center justify-end">
      <mia-cancel-button
        label="Abbrechen"
        type="button"
        size="small"
        :disabled="$wait.any"
        @click="$emit('cancel')"
      />

      <mia-submit-button
        label="Einverständniserklärung erzeugen"
        type="button"
        class="ml-4"
        size="small"
        :is-loading="$wait.is('generating connect onboarding document')"
        :disabled="$wait.any"
        @click="generateAndDownload"
      />
    </mia-modal-footer>
  </mia-modal>
</template>
